var map = {
	"./area.svg": 33,
	"./arrow-left.svg": 34,
	"./arrow-right.svg": 35,
	"./b-certified.svg": 36,
	"./bed.svg": 37,
	"./chevron-l.svg": 38,
	"./chevron-r.svg": 39,
	"./climate.svg": 40,
	"./close.svg": 41,
	"./co2.svg": 42,
	"./down.svg": 43,
	"./down2.svg": 44,
	"./download.svg": 45,
	"./followup.svg": 46,
	"./grid.svg": 47,
	"./growth.svg": 48,
	"./jobs-2.svg": 49,
	"./jobs.svg": 50,
	"./landfill.svg": 51,
	"./linkedin.svg": 52,
	"./literacy.svg": 53,
	"./lives.svg": 54,
	"./menu.svg": 55,
	"./minus.svg": 56,
	"./organic-2.svg": 57,
	"./organic.svg": 58,
	"./plane.svg": 59,
	"./plus.svg": 60,
	"./question.svg": 61,
	"./regenerative.svg": 62,
	"./renewable.svg": 63,
	"./savings.svg": 64,
	"./sdg1.svg": 65,
	"./sdg10.svg": 66,
	"./sdg11.svg": 67,
	"./sdg12.svg": 68,
	"./sdg13.svg": 69,
	"./sdg15.svg": 70,
	"./sdg16.svg": 71,
	"./sdg17.svg": 72,
	"./sdg2.svg": 73,
	"./sdg3.svg": 74,
	"./sdg4.svg": 75,
	"./sdg5.svg": 76,
	"./sdg7.svg": 77,
	"./sdg8.svg": 78,
	"./sdg9.svg": 79,
	"./shower.svg": 80,
	"./target.svg": 81,
	"./twitter.svg": 82,
	"./up.svg": 83
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32;